<template>
  <div class="flex flex-col space-y-4">
    <div v-for="(example, index) in examples" :key="index" class="text-example">
      <div class="inline text-xl text-sky-700" v-html="highlightText(example.furigana, highlight)" />
      <TextSpeak lang="ja" :text="example.ja" />
      <div class="text-lg">{{ example.vi }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    examples: array
    highlight?: string
  }>()

  import { highlightText } from '$/utils'
  import TextSpeak from '&/TextSpeak.vue'
</script>

<style scoped lang="sass">
  :deep(.text-example)
    rt
      color: #475569
</style>
